module.exports = __webpack_public_path__ + "141d4a85/img/comment-question-icon.7dd26e04.svg";